import { Helmet } from "react-helmet-async";

const SITE = "https://www.filmistani.com";
const DEFAULT_OG = `${SITE}/og-cover.jpg`;

/**
 * Per-page SEO component. Drop at the top of any page to set unique
 * <title>, meta description, canonical URL, OG tags, Twitter card, and
 * optional JSON-LD structured data.
 *
 * Usage:
 *   <Seo
 *     title="Inception (2010) · IMDb 8.8"
 *     description="Cobb leads a team of dream thieves..."
 *     path="/title/movie/27205"
 *     image="https://image.tmdb.org/.../poster.jpg"
 *     jsonLd={{ "@type":"Movie", ... }}
 *   />
 */
export default function Seo({
  title,
  description,
  path = "/",
  image,
  type = "website",
  jsonLd = null,
  noindex = false,
  robots = null,
  keywords = null,
}) {
  const fullTitle = title ? `${title} — Filmistani` : "Filmistani — Movie & Web Series Recommendations · Hindi, Tamil, Telugu, Korean & Global Cinema";
  const url = `${SITE}${path}`;
  const desc = description || "Hand-picked movie & web series discovery for Hindi, Tamil, Telugu, Malayalam, Kannada, English & Korean cinema. Live IMDb ratings, curated rails and Ask Filmi — your cinema buddy.";
  const ogImg = image || DEFAULT_OG;
  // Default robots: max-image-preview + max-snippet for all public pages
  const robotsContent = noindex
    ? "noindex,follow"
    : (robots || "index,follow,max-image-preview:large,max-snippet:-1,max-video-preview:-1");
  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {keywords && <meta name="keywords" content={keywords} />}
      <link rel="canonical" href={url} />
      <link rel="alternate" hreflang="en-IN" href={url} />
      <link rel="alternate" hreflang="x-default" href={url} />
      <meta name="robots" content={robotsContent} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:url" content={url} />
      <meta property="og:type" content={type} />
      <meta property="og:image" content={ogImg} />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={ogImg} />
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  );
}
